export default "__VITE_ASSET__b8907045__"